import { render, staticRenderFns } from "./FooterFox.vue?vue&type=template&id=110459ab&scoped=true&"
import script from "./FooterFox.vue?vue&type=script&lang=js&"
export * from "./FooterFox.vue?vue&type=script&lang=js&"
import style0 from "./FooterFox.vue?vue&type=style&index=0&id=110459ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110459ab",
  null
  
)

export default component.exports